export const GENERATOR_VALIDATION = {
    character_amount: { required: 'Jumlah karakter wajib diisi' },
    total: { required: 'Total voucher wajib diisi' },
}

export const DUPLICATE_VALIDATION = {
    new_code: { required: 'Kode voucher wajib diisi' },
    target_code: { required: 'Kode voucher wajib diisi' },
}
